import React from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import useIsUserActive from './useIsUserActive/useIsUserActive';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import ToggleFullscreenButton from '../MenuBarClient/ToggleFullScreenButton/ToggleFullScreenButton';
import { useTranslation } from 'react-i18next';
import CompositeAudioButton from '../Controls/CompositeAudioButton/CompositeAudioButton';
import CompositeVideoButton from '../Controls/CompositeVideoButton/CompositeVideoButton';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { LocalDataTrack } from 'twilio-video';
import ChatButton from '../ChatButton/ChatButton';
import useRemoteDatatrack from '../../hooks/useDatatrackParticipant/useRemoteDatatrack';

const useStyles = makeStyles<Theme>(theme => ({
  overall: {
    display: 'inline-flex',
    position: 'absolute',
    bottom: '0%',
    width: '100%',
    left: '0%',
    height: '78px',
    justifyItems: 'bottom',
    alignItems: 'center',
  },
  container: {
    display: 'flex',
    position: 'absolute',
    left: '0%',
    zIndex: 3,
    transition: 'opacity 1.2s, transform 1.2s, visibility 0s 1.2s',
    visibility: 'visible',
    maxWidth: 'min-content',
    justifyItems: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      bottom: `${theme.sidebarMobileHeight + 3}px`,
      padding: 0,
    },
    width: `${window.innerWidth}`,
  },
  container1: {
    display: 'flex',
    position: 'absolute',
    marginLeft: '70px',
    zIndex: 3,
    transition: 'opacity 1.2s, transform 1.2s, visibility 0s 1.2s',
    visibility: 'visible',
    maxWidth: 'min-content',
    [theme.breakpoints.down('xs')]: {
      bottom: `${theme.sidebarMobileHeight + 3}px`,
    },
  },
  container2: {
    display: 'flex',
    position: 'absolute',
    marginLeft: '145px',
    zIndex: 3,
    transition: 'opacity 1.2s, transform 1.2s, visibility 0s 1.2s',
    visibility: 'visible',
    maxWidth: 'min-content',
    [theme.breakpoints.down('xs')]: {
      bottom: `${theme.sidebarMobileHeight + 3}px`,
    },
  },
  containerChat: {
    display: 'flex',
    position: 'absolute',
    right: '5%',
    marginRight: '75px',
    zIndex: 3,
    transition: 'opacity 1.2s, transform 1.2s, visibility 0s 1.2s',
    visibility: 'visible',
    maxWidth: 'min-content',
    [theme.breakpoints.down('xs')]: {
      bottom: `${theme.sidebarMobileHeight + 3}px`,
      padding: 0,
    },
    width: `${window.innerWidth}`,
  },
  containerRight: {
    display: 'flex',
    position: 'absolute',
    right: '5%',
    zIndex: 1,
    transition: 'opacity 1.2s, transform 1.2s, visibility 0s 1.2s',
    visibility: 'visible',
    maxWidth: 'min-content',
    [theme.breakpoints.down('xs')]: {
      bottom: `${theme.sidebarMobileHeight + 3}px`,
      padding: 0,
    },
    width: `${window.innerWidth}`,
  },
}));

export default function ControlsClient(props: any) {
  const classes = useStyles();
  const roomState = useRoomState();
  const isUserActive = useIsUserActive();
  const isDisconnected = roomState === 'disconnected';
  const showControls = isUserActive || isDisconnected;
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const { localTracks } = useVideoContext();
  const remoteDatatrack = useRemoteDatatrack();

  const localDataTrack = localTracks.find(track => track.kind === 'data') as LocalDataTrack;

  return (
    <div className={clsx(classes.overall)}>
      <div className={clsx(classes.container, { showControls })}>
        <ToggleFullscreenButton />
      </div>
      <div className={clsx(classes.container1, { showControls })}>
        <CompositeAudioButton />
      </div>
      <div className={clsx(classes.container2, { showControls })}>
        <CompositeVideoButton />
      </div>
      {!isDisconnected ? (
        <div className={clsx(classes.containerChat, { showControls })}>
          <ChatButton
            t={t}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            localDatatrack={localDataTrack}
            remoteDatatrack={remoteDatatrack}
            isDisconnected={isDisconnected}
          />
        </div>
      ) : null}
    </div>
  );
}
